<template lang="pug">
    include purchased-items.pug
</template>

<i18n>
{
    "en": {
        "{total} selected": "{total} selected"
    },
    "de": {
        "{total} selected": "{total} ausgewählt",
        "Edit Article": "Artikel bearbeiten",
        "Article could not be saved": "Artikel konnte nicht gespeichert werden",
        "Article saved successfully!": "Artikel erfolgreich gespeichert!",
        "Quantity": "Anzahl",
        "Available": "Verfügbar",
        "Sold": "Verkauft",
        "Re-Ordered": "Im Zulauf",
        "Stock": "Lager",
        "shipped": "versendet",
        "canceled": "storniert",
        "reserved": "reserviert",
        "missing": "fehlend",
        "re-ordered": "im Zulauf",
        "packed": "versandfertig",
        "To": "An",
        "With": "Mit",
        "By": "Von",
        "Point Of Sale": "Kasse",
        "shipping package slip": "Paketschein anzeigen",
        "Add article to cart": "Artikel in den Warenkorb legen",
        "no selectable properties": "keine auswählbare Attribute",
        "Show filters": "Filter anzeigen",
        "Hide filters": "Filter verbergen",
        "Packing slip": "Paketschein",
        "Packing slip PDF": "Paketschein PDF",
        "Preview could not be rendered": "Vorschau konnte nicht gerendered werden",
        "Missing PDF": "PDF konnte nicht gefunden werden",
        "Send packing list via email": "Packliste per Email versenden",
        "Inform selected warehouses by email": "Ausgewählte Läger per Email informieren",
        "View PDF": "PDF anzeigen",
        "From": "Von",
        "Subject": "Betreff",
        "Preview": "Vorschau",
        "Print": "Drucken",
        "Download": "Herunterladen",
        "Email preview": "Email vorschau",
        "Send now": "Jetzt versenden",
        "new": "Neu"
    }
}
</i18n>

<script>
import _ from 'lodash'
import uniqid from 'uniqid';

// import { compareAsc, compareDesc } from 'date-fns';
import printJS from 'print-js-updated';
import pdf from 'vue-pdf'

import pinia from '@/pinia';
import { useSetupStore, useShopPurchaseStore } from '@/stores';

import articles from './Mixins/articles'
// import PointOfSaleApi from '@/extensions/shop/pointOfSale/store/api/pointOfSale';
import PurchaseApi from '@/extensions/shop/store/api/purchase';
import { ensureFreshToken } from '@/helpers'
import { a4DrawerSize, a4DrawerSizeEstimate } from '@/utils/a4DrawerSize';

export default {
    name: 'Articles',
    mixins: [articles],
    data: () => ({
        document: {
            visibility: false,
            type: undefined,
            context: undefined,
            size: '40%',
            title: undefined,
            loading: false,
            saving: false,
            submit: false,
            error: false,
        },
        modal: {
            visibility: false,
            title: undefined,
            loading: false,
            saving: false,
            submit: false,
            error: false,
            form: undefined,
            rules: {},
        },
        sortables: [],
    }),
    components: {
        pdf
    },
    computed: {
        loading() {
            return this.ui.purchasedItemsPaginated.loading;
        },
        sort() {
            var variables = this.articlesPaginated.variables;
            var defaultSort = this.articlesPaginated.defaultSort || { field: 'id', direction: 'desc' };
            var order = (variables.order !== undefined && variables.order !== '') ? variables.order : defaultSort.field;
            var direction = (variables.direction !== undefined && variables.direction !== '') ? variables.direction : defaultSort.direction;
            return { field: order, direction: direction };
        },
        currency() {
            return _.get(this.form, 'currency', 'EUR')
        },
        previewUrl() {
            if (this.document.data) return this.document.data.preview.getUrl();
        },
        validModalForm() {
            let valid = true

            if (this.modal.form) {
                if (this.modal.form.stocks.find(el => _.get(el.pivot.status, 'key') === 'missing')) {
                    valid = false
                }

                // let qty = 0
                // this.modal.form.stocks.forEach(el => qty += el.pivot.qty)
                // if (qty < this.modal.form.qty) valid = false
            }

            return valid
        },
        modalStocks() {
            const stocks = _.get(this.modal.form, 'article.stocks') || []
            return stocks.filter(stock => {
                // let enabled = true;

                // const start = stock.pivot.sellable_from;
                // if (start && enabled) enabled = compareAsc(new Date(), start) > 0;

                // const end = stock.pivot.sellable_to;
                // // if (end && enabled) enabled = compareDesc(new Date(), addDays(end, 1)) > 0
                // if (end && enabled) enabled = compareDesc(new Date(), end) > 0;

                // return (enabled && stock.pivot.qty > 0) || this.modal.form.stocks.find(el => el.key === stock.key)

                return stock;
            })
        },
        includeWebShopPurchases() {
            return true;
        },
        includeInternals() {
            return true;
        },
        includePointOfSalePurchases() {
            return true;
        },
        articlesPaginated() {
            const articlesPaginated = _.cloneDeep(this.purchasedItemsPaginated);
            articlesPaginated.items.forEach(item => {
                if (item.shippingPackages && item.shippingPackages.length) {
                    item.stocks.forEach(stock => {
                        // find shipping package
                        const shippingPackage = item.shippingPackages.find(el => {
                            return el.items.find(el => el.id === item.id && _.get(el.pivot, 'stock.id') === stock.id)
                        })
                        if (shippingPackage) {
                            stock.pivot.shippingPackage = shippingPackage
                        }
                    })
                }
            })
            return articlesPaginated;
        },
        shopPurchaseStore() {
            return useShopPurchaseStore(pinia);
        },
        form() {
            return this.shopPurchaseStore.form;
        },
        options() {
            return this.shopPurchaseStore.options;
        },
        ui() {
            return this.shopPurchaseStore.ui;
        },
        purchasedItemsPaginated() {
            // needs to be named "articlesPaginated" for the mixin
            return this.shopPurchaseStore.purchasedItemsPaginated;
        },
    },
    methods: {
        getCurrency(item) {
            return _.get(item, 'currency')
        },
        showShippingPackageSlipDialog(shippingPackage) {
            this.$set(this.document, 'data', {
                preview: {
                    name: this.$t('Packing slip PDF'),
                    filename: `${shippingPackage.id}-shipping_package-slip.pdf`, // TODO: change as soon as the filename becomes configurable
                    pagination: { total: 1, current: 1 },
                    getUrl: () => {
                        if (shippingPackage.latestSlip) {
                            // TODO
                        }
                        else return PurchaseApi.shippingPackageSlipRenderingUrl(shippingPackage.id)
                    },
                }
            });

            this.document.type = 'pdf-preview';
            this.document.context = 'packing-list';
            this.document.title = this.$t('Packing slip PDF');
            this.document.visibility = true;
            this.document.loading = true;
            this.document.submit = false;
        },
        closeDocument() {
            this.document.visibility = false;
        },
        // As wide as a whole A4 page needs at this window height.
        fitDocumentDrawer() {
            if (this.document.type !== 'pdf-preview') return;
            this.document.size = a4DrawerSizeEstimate();
            this.$nextTick(() => {
                this.document.size = a4DrawerSize(this.$el.querySelector('.el-drawer__wrapper.document')) || this.document.size;
            });
        },
        resetDocument() {
            this.document = {
                visibility: false,
                type: 'email-preview',
                context: undefined,
                size: '40%',
                title: undefined,
                loading: false,
                saving: false,
                submit: false,
                error: false,
            };

            const iframe = this.$refs['preview-iframe']
            if (iframe) {
                iframe.contentWindow.document.open();
                iframe.contentWindow.document.write('');
                iframe.contentWindow.document.close();
            }
        },
        async printPreview() {
            // this.$refs['pdf-preview'].print();
            await ensureFreshToken();
            const url = this.document.data.preview.getUrl();
            printJS({ printable: url });
        },
        async downloadPreview() {
            await ensureFreshToken();
            const element = document.createElement('a');
            const url = this.document.data.preview.getUrl();
            element.setAttribute('href', `${url}&download`);
            // NOTE: does not work
            // element.setAttribute('download', this.document.data.preview.filename);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        },
        previewLoaded() {
            // this.refreshAuthentification();
            if (this.document.data && this.document.data.preview) {
                switch (this.document.type) {
                    case 'pdf-preview':
                        setTimeout(() => {
                            this.$set(this.document, 'loading', false);
                        }, 150)
                        break;

                    default:
                    case 'email-preview':
                        setTimeout(() => {
                            this.$set(this.document.data.preview, 'loading', false);
                        }, 150)
                        break;
                }
            }
        },
        previewError(error) {
            let message;
            switch (error.name) {
                case 'MissingPDFException':
                    message = {
                        title: this.$t('An error occurred!'),
                        message: this.$t('Missing PDF'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    }
                    break;

                default:
                    message = {
                        title: this.$t('An error occurred!'),
                        message: this.$t('Preview could not be rendered'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    }
            }

            if (this.document.data && this.document.data.preview) {
                switch (this.document.type) {
                    case 'pdf-preview':
                        setTimeout(() => {
                            this.closeDocument()
                        }, 300)
                        break;

                    default:
                    case 'email-preview':
                        this.resetDocument()
                        break;
                }
            }

            this.$notify.error(message)
        },
        updatePreviewPagination(key, value) {
            if (this.document.data && this.document.data.preview) {
                let timeout = 0

                if (key === 'current') {
                    if (this.$refs.preview.scrollTop) {
                        timeout = 200
                    }

                    this.$refs.preview.scroll({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    })
                }

                setTimeout(() => {
                    this.$set(this.document.data.preview.pagination, key, value);
                }, timeout);
            }
        },
        editPurchasedItem(item) {
            this.modal.title = item.name
            this.modal.form = _.cloneDeep(item);

            //  add possibly missing stocks to article

            this.modal.form.stocks.forEach(stock => {
                const articleStock = this.modal.form.article.stocks.find(el => el.id === stock.id)
                if (! articleStock) {
                    this.modal.form.article.stocks.push({
                        id: stock.id,
                        key: stock.key,
                        name: stock.name,
                        pivot: { qty: 0 }
                    })
                } else if (articleStock.pivot.qty >= stock.pivot.qty_limit) {
                    // this.updateModalFormStockPivot(stock.id, 0)
                    // this.$nextTick(() => {
                    //     this.updateModalFormStockPivot(stock.id, Math.min(stock.pivot.qty, articleStock.pivot.qty))
                    // })
                }
            })

            this.$nextTick(() => {
                this.modal.visibility = true;
            });
        },
        updateModalFormStockPivot(id, qty) {
            const purchasedItem = this.articlesPaginated.items.find(el => el.id === this.modal.form.id)
            let originalItemStock = purchasedItem.stocks.find(el => el.id === id)

            let purchasedItemStock = this.modal.form.stocks.find(el => el.id === id)
            let articleStock = this.modal.form.article.stocks.find(el => el.id === id)

            // check if item stock pivot exists
            // clone the original one or create a new one if not
            if (! purchasedItemStock) {
                if (originalItemStock) {
                    this.$set(this.modal.form.stocks, this.modal.form.stocks.length, _.cloneDeep(originalItemStock))
                    purchasedItemStock = this.modal.form.stocks.find(el => el.id === id)
                    this.$set(purchasedItemStock.pivot, 'qty', 0)
                } else {
                    purchasedItemStock = {
                        id: articleStock.id,
                        key: articleStock.key,
                        name: articleStock.name,
                        pivot: {
                            id: uniqid('new:'),
                            qty: 0,
                        }
                    }

                    this.$set(this.modal.form.stocks, this.modal.form.stocks.length, purchasedItemStock)
                    originalItemStock = _.cloneDeep(purchasedItemStock)
                }
            }

            // update existing item stock pivot
            if (articleStock) {
                // decrease/increase available stock qty
                let diff
                if (purchasedItemStock.pivot.qty_limit == null) {
                    diff = qty - purchasedItemStock.pivot.qty
                } else {
                    // if (qty > purchasedItemStock.pivot.qty_limit) qty = purchasedItemStock.pivot.qty_limit
                    diff = qty - purchasedItemStock.pivot.qty_limit
                }

                this.$set(articleStock.pivot, 'qty', Math.max(articleStock.pivot.qty - diff, 0))
            }

            if (qty > 0) {
                if (purchasedItemStock.pivot.qty_limit === null || qty <= purchasedItemStock.pivot.qty_limit) {
                    if (purchasedItemStock.pivot.status) purchasedItemStock.pivot.status = null
                    if (purchasedItemStock.pivot.pointOfSale) purchasedItemStock.pivot.pointOfSale = null
                    if (purchasedItemStock.pivot.qty_limit != null) purchasedItemStock.pivot.qty_limit = null
                }

                this.$set(purchasedItemStock.pivot, 'qty', qty)
            } else {
                let i = this.modal.form.stocks.findIndex(el => el.id === id)
                if (i >= 0) this.$delete(this.modal.form.stocks, i)
            }

            if (qty !== _.get(originalItemStock, 'pivot.qty', 0)) this.$set(articleStock, 'notify', true)
            else this.$delete(articleStock, 'notify')

            let sum = 0
            this.modal.form.stocks.forEach(el => sum += el.pivot.qty)
            this.modal.form.pending_delivery_qty = this.modal.form.qty - sum

            if (this.modal.form.pending_delivery_qty < 0) {
                // find missing stock_item or get first
                const stock = this.modal.form.stocks.find(el => _.get(el.pivot.status, 'key') === 'missing')
                    || this.modal.form.stocks.find(el => el.id !== id && el.pivot.qty > 0)
                    || this.modal.form.stocks.find(el => el.pivot.qty > 0)

                this.$nextTick(() => {
                    this.updateModalFormStockPivot(stock.id, stock.pivot.qty + this.modal.form.pending_delivery_qty)
                })
            }
        },
        removeModalFormStockPivotStatus(id) {
            const purchasedItemStock = this.modal.form.stocks.find(el => el.id === id)
            if (purchasedItemStock) {
                this.$set(purchasedItemStock.pivot, 'status', null)
                this.$set(purchasedItemStock.pivot, 'pointOfSale', null)
                this.$set(purchasedItemStock.pivot, 'qty_limit', null)
            }
        },
        resetModal() {
            this.modal = {
                visibility: false,
                title: undefined,
                loading: false,
                saving: false,
                submit: false,
                error: false,
                form: undefined,
                rules: {},
            }
        },
        submitModalForm() {
            this.modal.saving = true;
            this.updatePurchasedItemStocks(this.modal.form)
                .then(() => {
                    this.$notify.success({
                        title: this.$t('Article saved successfully!'),
                        iconClass: 'fas el-icon-fa-check',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                    this.refetch().then(this.closeModal)
                        .finally(() => {
                            this.modal.saving = false;
                        })
                })
                .catch(err => {
                    this.modal.saving = false;
                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Article could not be saved'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000,
                    })
                })
        },
        updateLoading(value) {
            this.shopPurchaseStore.updatePurchasedItemsPaginationLoading(value);
        },
        defineItemsPerPage(value) {
            this.shopPurchaseStore.definePurchasedItemsPerPage(value);
        },
        defineCurrentPage(value) {
            this.shopPurchaseStore.definePurchasedItemsCurrentPage(value);
        },
        defineActiveColumns(value) {
            this.shopPurchaseStore.definePurchasedItemsActiveColumns(value);
        },
        defineFilterValue(payload) {
            this.shopPurchaseStore.definePurchasedItemsFilterValue(payload);
        },
        defineFilterVisibility(value) {
            this.shopPurchaseStore.definePurchasedItemsFilterVisibility(value);
        },
        defineSort(payload) {
            this.shopPurchaseStore.definePurchasedItemsSorting(payload);
        },
        fetchArticlesPaginated(payload) {
            return this.shopPurchaseStore.fetchPurchasedItemsPaginated(payload);
        },
        updatePurchasedItemStocks(payload) {
            return this.shopPurchaseStore.updatePurchasedItemStocks(payload);
        },
        saveFilterVisibility(payload) {
            return this.setupStore.saveFilterVisibility(payload);
        },
    }
}
</script>

<style lang="sass" scoped>

#app
    section.articles
        padding: 0
    //         ::v-deep
    //             .column.name
    //                 position: relative
    //                 .will-be-notified
    //                     position: absolute
    //                     left: -15px
    //                     top:  0
    //                     font-size: 11px
    //                     color: $--color-info
    //
    // .item-modal-form
    // .el-form > .el-form-item:last-child
    //     margin-bottom: 0
    // .modal-footer
    //     display: flex
    //     justify-content: space-between
    //     .left
    //         display: flex
    //         align-items: center
    //         .switch
    //             height: 28px
    //             line-height: 28px

    .price .sale
        color: $--color-danger

    ul.no-style-list
        padding-left: 0

    small.gray
        color: lighten($color-grey-text, 10%)
    .status
        // display: inline-block
        // border-radius: 100px
        // line-height: 0
        // position: relative
        // margin-right: 4px
        // width: 20px
        // height: 20px
        // background-color: lighten($color-grey-text, 10%)
        // bottom: -4px
        &.shipped
            i
                color: $--shop-color-primary
        &.canceled
            i
                color: $--color-danger
        &.reserved
            i
                color: $--color-info
        &.missing
            i
                color: $--color-warning
        &.re-ordered
            i
                // color: $--color-primary
                color: $--color-text-primary
        &.packed
            i
                color: $--color-success
        nobr i
            // width: 20px
                font-size: 1rem
                margin-right: 0.5rem
                text-align: center
    .spacer
        margin-top: 0.5rem

    section.articles
        .el-drawer__wrapper.document
            ::v-deep .el-drawer
                min-width: 600px
                max-width: 90%
                .el-form
                    display: flex
                    flex-direction: column
                    .body
                        position: relative
                        flex-grow: 1
                        width: 100%
                iframe,
                .preview
                    // width: 100%
                    // flex-grow: 1
                    // max-height: calc(100vh - 135px)
                    position: absolute
                    left: 0
                    top: 0
                    width: 100%
                    height: 100%
                    max-width: 100%
                    max-height: 100%
                    overflow: auto
                .pill
                    // padding: 2px 6px
                    // background: #e2e2e2
                    // margin: 2px
                    // display: inline-block
                    // border-radius: 3px
                    &:not(:last-child):after
                        content: ', '
                        margin-right: 2px
                .from-to b + span.pill
                    margin-left: 4px
                .meta
                    padding: 20px
                    padding-top: 0
                    font-size: 0.8rem
                    display: grid
                    grid-template-rows: auto auto
                    grid-template-columns: auto auto
                    .subject
                        grid-row: 2
                        margin-top: 1rem
                        b + span
                            margin-left: 4px
                    .attachments
                        grid-column: 2
                        text-align: right
                        display: flex
                        flex-direction: column
                        align-items: flex-end
                        /* justify-content: flex-end */
                        ul
                            list-style: none
                            padding: 0
                            margin: 0
        .el-drawer__wrapper.preview
            min-width: 560px
            max-width: calc(90% - 40px)
        .drawer-footer
            align-items: center

        .preview
            padding: 2rem 20px
            display: flex
            align-items: center
            justify-content: center
            & > span
                width: 100%
                flex-grow: 1
                margin: auto 0
            &.loaded
                background: #babfc3
                & > span
                    box-shadow: 0 4px 5px 0 rgba(0,0,0,0.14), 0 1px 10px 0 rgba(0,0,0,0.12), 0 2px 4px -1px rgba(0,0,0,0.3)

.item-modal-form
    .info
        flex-grow: 1
        min-width: 0
        padding: 6px 0
        .row
            display: flex
            gap: 0.5rem
            & + .row
                margin-top: 0.25rem
        .name
            flex-grow: 1
            min-width: 0
            white-space: nowrap
            overflow: hidden
            text-overflow: ellipsis
        .sku
            flex-grow: 1
        ::v-deep label
            font-weight: bold
        label + span.value:before
            content: ' '
        label
            font-style: italic
            &.small
                font-size: 0.8em

    hr
        border: none
        border-top: 1px solid #dcdfe6
        margin: 1rem 0
        // width: 100%
        // height: 12px
        // background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg width='20' height='12' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25 1c-5 0-5 10-10 10S10 1 5 1 0 11-5 11-10 1-15 1' stroke='%23CBD5DF' stroke-width='2' fill='none' fill-rule='evenodd' stroke-linecap='square'/%3E%3C/svg%3E")

td.col-left.status.missing,
td.col-center.available.missing
    font-weight: bold
    color: $--color-danger

table .less-padding
    padding-left: 10px
    padding-right: 10px

.re-ordered
    color: $--color-danger

.modal-footer
    display: flex
    justify-content: space-between
    .left
        display: flex
        align-items: center
        .switch
            height: 28px
            line-height: 28px

.default-table
    th
        white-space: nowrap
</style>
